module.exports = __webpack_public_path__ + "static/media/Megazone.4ff9e407.svg";